import React, { useEffect, useState, useRef } from "react";
import Table from "../../../Utils/Table/Table1";
import { fDateTimesec } from "../../../Utils/Date_format/datefromat";
import { gettradehistory, getINRtradehistory } from "../../../Services/Admin/Addmin";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeftRight, X, LockOpen, Logs, Trash, Trash2, Redo2 } from "lucide-react";
import {
  getAdminName,
  switchOrderType,
  InrswitchOrderType
} from "../../../Services/Superadmin/Superadmin";
import { useLivePrices } from "../../../context/LivePriceContext";
import { getAllswitchOrderTypedata, InrgetAllswitchOrderTypedata, ReopenExitTrade, InrReopenExitTrade, DeleteTradeforuser, InrDeleteTradeforuser, ReopenDeleteTrade, INrReopenDeleteTrade, DeleteOrderTradeLogs, INRDeleteOrderTradeLogs } from "../../../Services/Admin/Addmin";
import Swal from "sweetalert2";
import { getUserFromToken } from "../../../Utils/TokenVerify";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";


const SuperAdminTradeHistory = () => {
  const TokenData = getUserFromToken();
  const [data, setData] = useState([]);
  const [userName, setUserName] = useState();
  const [Userid, setUserId] = useState();
  const [Search, setSearch] = useState("");
  const [userNameList, setUserNameList] = useState([]);
  const [userNamed, setUserNamed] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const { livePrices } = useLivePrices();

  const [logsmodel, setLogsmodel] = useState(false);
  const [logsdata, setLogsdata] = useState([])
  const [tradeStatus, setTradeStatus] = useState(""); // New state for open/close filter

  const [deletelogs, setDeleteLogs] = useState(false);
  const [tradeLogs, setTradeLogs] = useState([]);


  const [activeMarket, setActiveMarket] = useState("USD");
const decimalPoint = activeMarket === "INR" ? 2 : 4;
  const navigate = useNavigate()

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);


  //   const downloadExcel = () => {
  //   if (!data || data.length === 0) {
  //     console.log("No data to download");
  //     toast("No data to download");
  //     return;
  //   }


  //   // const safeValue = (val) =>
  //   // val === undefined || val === null || val === "" ? "-" :String(val);

  // const safeValue = (val, digits = 3) => {
  //   if (val === undefined || val === null || val === "") return "-";

  //   // agar number hai ya number ban sakta hai
  //   if (!isNaN(val) && val !== "") {
  //     return Number(val).toFixed(digits); // decimal fix
  //   }

  //   // warna string as it is
  //   return String(val);
  // };


  //   const excelData = data.map((row, index) => {
  //     const isBuySell = row.signal_type === "buy_sell";
  //     const isSellBuy = row.signal_type === "sell_buy";

  //     return {
  //      "S.No": String(index + 1),

  //       "User Name": safeValue(row.userName),
  //       "Symbol": safeValue(row.symbol),

  //       "Signal Type": isBuySell ? "BUY" : isSellBuy ? "SELL" : "-",

  //       //status
  //    "Status": getTradeStatus(row),


  //       //  Entry Price
  //       "Entry Price": isBuySell
  //         ? safeValue(row.buy_price)
  //         : safeValue(row.sell_price),

  //       // Exit Price
  //       "Exit Price": isBuySell
  //         ? safeValue(row.sell_price)
  //         : safeValue(row.buy_price),

  //         "Profit/Loss": isBuySell
  //         ? safeValue(row.profitloss)
  //         : safeValue(row.profitloss),

  //       //  Entry Lot
  //       "Entry Lot": isBuySell
  //         ? safeValue(row.buy_lot)
  //         : safeValue(row.sell_lot),

  //       //  Exit Lot
  //       "Exit Lot": isBuySell
  //         ? safeValue(row.sell_lot)
  //         : safeValue(row.buy_lot),

  //       //  Entry Time
  //       "Entry Time": isBuySell
  //         ? row.buy_time
  //           ? fDateTimesec(row.buy_time)
  //           : "-"
  //         : row.sell_time
  //         ? fDateTimesec(row.sell_time)
  //         : "-",

  //       //  Exit Time
  //       "Exit Time": isBuySell
  //         ? row.sell_time
  //           ? fDateTimesec(row.sell_time)
  //           : "-"
  //         : row.buy_time
  //         ? fDateTimesec(row.buy_time)
  //         : "-",
  //     };
  //   });

  //   const worksheet = XLSX.utils.json_to_sheet(excelData);

  // //  AUTO WIDTH LOGIC
  // const colWidths = Object.keys(excelData[0]).map((key) => {
  //   let maxLength = key.length;

  //   excelData.forEach((row) => {
  //     const value = row[key];
  //     if (value) {
  //       maxLength = Math.max(maxLength, value.toString().length);
  //     }
  //   });

  //   return { wch: maxLength + 6 }; // +3 for padding
  // });

  // worksheet["!cols"] = colWidths;

  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Trade History");

  //   const excelBuffer = XLSX.write(workbook, {
  //     bookType: "xlsx",
  //     type: "array",
  //   });

  //   const file = new Blob([excelBuffer], {
  //     type: "application/octet-stream",
  //   });

  //   saveAs(file, `Trade_History_${activeMarket}.xlsx`);
  // };

  const downloadExcel = async () => {
    try {


      // 🔹 EXCEL KE LIYE ALAG PAYLOAD
      const payload = {
        adminid: Userid?._id,
        userId: userNamed,
        fromDate,
        toDate,
        status: tradeStatus,
        search: Search,
        page: 1,
        limit: 100000, // 🔥 ONLY FOR EXCEL
      };

      let response;
      if (activeMarket === "INR") {
        response = await getINRtradehistory(payload);
      } else {
        response = await gettradehistory(payload);
      }

      const excelRows = response?.data || [];

      if (excelRows.length === 0) {
        toast.error("No data to download");
        return;
      }

      // 🔹 SAFE VALUE FUNCTION
      const safeValue = (val, digits = 3) => {
        if (val === undefined || val === null || val === "") return "-";
        if (!isNaN(val)) return Number(val).toFixed(digits);
        return String(val);
      };

      // 🔹 EXCEL DATA PREPARE
      const excelData = excelRows.map((row, index) => {
        const isBuySell = row.signal_type === "buy_sell";
        const isSellBuy = row.signal_type === "sell_buy";

        return {
          "S.No": index + 1,
          "User Name": safeValue(row.userName),
          "Symbol": safeValue(row.symbol),
          "Signal Type": isBuySell ? "BUY" : isSellBuy ? "SELL" : "-",
          "Status": getTradeStatus(row),

          "Entry Price": isBuySell
            ? safeValue(row.buy_price)
            : safeValue(row.sell_price),

          "Exit Price": isBuySell
            ? safeValue(row.sell_price)
            : safeValue(row.buy_price),

          "Profit/Loss": safeValue(row.profitloss),

          "Entry Lot": isBuySell
            ? safeValue(row.buy_lot)
            : safeValue(row.sell_lot),

          "Exit Lot": isBuySell
            ? safeValue(row.sell_lot)
            : safeValue(row.buy_lot),

          "Entry Time": isBuySell
            ? row.buy_time ? fDateTimesec(row.buy_time) : "-"
            : row.sell_time ? fDateTimesec(row.sell_time) : "-",

          "Exit Time": isBuySell
            ? row.sell_time ? fDateTimesec(row.sell_time) : "-"
            : row.buy_time ? fDateTimesec(row.buy_time) : "-",
        };
      });

      // 🔹 EXCEL CREATE
      const worksheet = XLSX.utils.json_to_sheet(excelData);

      // AUTO COLUMN WIDTH
      worksheet["!cols"] = Object.keys(excelData[0]).map((key) => {
        let max = key.length;
        excelData.forEach((row) => {
          if (row[key]) max = Math.max(max, row[key].toString().length);
        });
        return { wch: max + 6 };
      });

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Trade History");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAs(
        new Blob([excelBuffer], { type: "application/octet-stream" }),
        `Trade_History_${activeMarket}.xlsx`
      );

      toast.success("Excel downloaded successfully");
    } catch (err) {
      console.error(err);
      toast.error("Excel download failed");
    }
  };







  const fetchTradeLogs = async (row) => {
    try {
      const data = { id: row._id, userid: row?.userid };
      let response;
      if (activeMarket === "USD") {
        response = await DeleteOrderTradeLogs(data);

      } else {
        response = await INRDeleteOrderTradeLogs(data);

      }
      if (response.status) {
        setTradeLogs(response.data)
        setDeleteLogs(true)
      }
    } catch (error) {
      console.error('Error fetching trade logs:', error);
    }
  };


  useEffect(() => {
    GetUserName();
  }, []);




  useEffect(() => {
    getuserallhistory();
  }, [Userid, Search, userNamed, toDate, fromDate, tradeStatus, activeMarket, page, rowsPerPage]);




  const ReopenExitTradedata = async (row) => {
    try {

      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to reopen this trade?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, reopen it!',
        cancelButtonText: 'No, cancel'
      });

      if (result.isConfirmed) {
        const data = { userid: row.userid, id: row._id };
        let response;
        if (activeMarket === "USD") {
          response = await ReopenExitTrade(data);

        } else {
          response = await InrReopenExitTrade(data);

        }

        if (response.status) {
          Swal.fire(
            'Reopened!',
            'The trade has been reopened successfully.',
            'success'
          );
          getuserallhistory()
        } else {
          Swal.fire(
            'Error!',
            response.message || 'Something went wrong!',
            'error'
          );
        }
      } else {
        Swal.fire(
          'Cancelled',
          'The trade is safe',
          'info'
        );
      }
    } catch (error) {
      console.error(error);
      Swal.fire(
        'Error!',
        'Something went wrong while reopening trade.',
        'error'
      );
    }
  };


  const DeleteExitTradedata = async (row) => {
    try {

      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to delete this trade?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel'
      });

      if (result.isConfirmed) {
        const data = { userid: row.userid, id: row._id };
        let response;
        if (activeMarket === "USD") {
          response = await DeleteTradeforuser(data);

        } else {
          response = await InrDeleteTradeforuser(data);

        }

        if (response.status) {
          Swal.fire(
            'Deleted!',
            'The trade has been Deleted successfully.',
            'success'
          );
          getuserallhistory()
        } else {
          Swal.fire(
            'Error!',
            response.message || 'Something went wrong!',
            'error'
          );
        }
      } else {
        Swal.fire(
          'Cancelled',
          'The trade is safe',
          'info'
        );
      }
    } catch (error) {
      console.error(error);
      Swal.fire(
        'Error!',
        'Something went wrong while Delete trade.',
        'error'
      );
    }
  };



  const ReopenDeleteExitTradedata = async (row) => {
    try {

      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to Reopen this trade?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel'
      });

      if (result.isConfirmed) {
        const data = { userid: row.userid, id: row._id };
        let response;
        if (activeMarket === "USD") {
          response = await ReopenDeleteTrade(data);

        } else {
          response = await INrReopenDeleteTrade(data);

        }

        if (response.status) {
          Swal.fire(
            'Reopened!',
            'The trade has been Reopen deleted trade successfully.',
            'success'
          );
          getuserallhistory()
        } else {
          Swal.fire(
            'Error!',
            response.message || 'Something went wrong!',
            'error'
          );
        }
      } else {
        Swal.fire(
          'Cancelled',
          'The trade is safe',
          'info'
        );
      }
    } catch (error) {
      Swal.fire(
        'Error!',
        'Something went wrong while reopen Delete trade.',
        'error'
      );
    }
  };



  const logspage = (row) => {
    if (activeMarket === "USD") {
      navigate("/superadmin/trade-logs", { state: { row } });

    } else {
      navigate("/superadmin/inr-trade-logs", { state: { row } });

    }
  };



  const getuserallhistory = async () => {
    try {
      if (Userid === undefined || Userid === null) {
        return;
      }

      const data = {
        adminid: Userid._id,
        userId: userNamed,
        toDate: toDate,
        fromDate: fromDate,
        status: tradeStatus,
        page: page,
        limit: rowsPerPage,
        search: Search,
      };
      let response;
      if (activeMarket === "INR") {
        response = await getINRtradehistory(data);
      } else {
        response = await gettradehistory(data);
      }

      setUserNameList(response.allUsers || []);

      setTotalPages(response.pagination?.totalPages || 1);

      setData(response.data || []);

    } catch (error) { }
  };


  const getTradeStatus = (row) => {
    if (row.buy_price && row.sell_price) {
      return "Closed";
    } else if (row.buy_price || row.sell_price) {
      return "Open";
    }
    return "Unknown";
  };

  const columns = [
    {
      Header: "S.No",
      id: "rowIndex",
      Cell: ({ index }) => (page - 1) * rowsPerPage + index + 1,
    },
    { Header: "UserName", accessor: "userName" },
    { Header: "Symbol", accessor: "symbol" },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ row }) => {
        const status = getTradeStatus(row);
        return (
          // <span
          //   style={{
          //     color: status === "Open" ? "green" : status === "Closed" ? "#a72828ff" : "#6c757d",
          //     fontWeight: "bold",
          //     padding: "2px 8px",
          //     borderRadius: "12px",
          //     backgroundColor: status === "Open" ? "#fff3cd" : status === "Closed" ? "#d4edda" : "#f8f9fa",
          //     fontSize: "12px"
          //   }}
          // >
          //   {status === "Open" ? "🟢OPEN" : status === "Closed" ? "🟡CLOSED" : "❓ UNKNOWN"}
          // </span>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              padding: "4px 12px",
              borderRadius: "8px",
              backgroundColor: status === "Open" ? "#e0ffe8" : "#ffe0e0",
              color: status === "Open" ? "#067a32" : "#b91c1c",
              fontWeight: "bold",
              fontSize: "12px"
            }}
          >
            <span style={{ fontSize: "10px" }}>
              {status === "Open" ? "✔️" : "⛔"}
            </span>
            {status}
          </span>


        );
      },
    },
    {
      Header: "Entry Price",
      accessor: "buy_price",
      Cell: ({ row }) => {
        const buy_price = row.buy_price;
        const signal_type = row.signal_type;
        if (signal_type === "buy_sell") {
          return buy_price ? buy_price.toFixed(decimalPoint) : "-";
        } else {
          return row.sell_price ? row.sell_price.toFixed(decimalPoint) : "-";
        }
      },
    },
    {
      Header: "Exit Price",
      accessor: "sell_price",
      Cell: ({ row }) => {
        const buy_price = row.buy_price;
        const signal_type = row.signal_type;
        const livePrice = activeMarket === "INR" ? livePrices[row.token] : livePrices[row.symbol?.toLowerCase()];

        if (signal_type === "sell_buy") {
          return buy_price ? buy_price.toFixed(decimalPoint) : livePrice;
        } else {
          return row.sell_price ? row.sell_price.toFixed(decimalPoint) : livePrice;
        }
      },
    },
    {
      Header: "P/L",
      accessor: "P/L",
      Cell: ({ row }) => {
        const signal_type = row.signal_type;
        const sellPrice = row.sell_price;
        const buyPrice = row.buy_price;
        const buyQty = row.buy_qty;

        if (sellPrice && buyPrice && buyQty) {

          const profitLoss = (sellPrice - buyPrice) * buyQty;
          const formattedProfitLoss = profitLoss.toFixed(decimalPoint);

          const color = profitLoss > 0 ? "green" : "red";

          return (
            <span style={{ color }}>

              {formattedProfitLoss}
            </span>
          );
        } else if (signal_type === "buy_sell") {
          const livePrice = activeMarket === "INR" ? livePrices[row.token] : livePrices[row.symbol?.toLowerCase()];
          if (livePrice) {
            const profitLoss = (livePrice - buyPrice) * row.buy_qty;
            const formattedProfitLoss = profitLoss.toFixed(decimalPoint);
            const color = profitLoss > 0 ? "green" : "red";
            return <span style={{ color }}>{formattedProfitLoss}</span>;
          }
        } else if (signal_type === "sell_buy") {
          const livePrice = activeMarket === "INR" ? livePrices[row.token] : livePrices[row.symbol?.toLowerCase()];
          if (livePrice) {
            const profitLoss = (row.sell_price - livePrice) * row.sell_lot;
            const formattedProfitLoss = profitLoss.toFixed(decimalPoint);
            const color = profitLoss > 0 ? "green" : "red";
            return <span style={{ color }}>{formattedProfitLoss}</span>;
          }
        }

        return "-";
      },
    },
    {
      Header: "Entry lot / Qty",
      accessor: "buy_lot",
      Cell: ({ row }) => {
        const signal_type = row.signal_type;
        if (signal_type === "buy_sell") {
          return row.buy_lot ? row.buy_lot : "-";
        } else {
          return row.sell_lot ? row.sell_lot : "-";
        }
      },
    },
    {
      Header: "Exit lot  / Qty",
      accessor: "sell_lot",
      Cell: ({ row }) => {
        const signal_type = row.signal_type;
        if (signal_type === "sell_buy") {
          return row.buy_lot ? row.buy_lot : "-";
        } else {
          return row.sell_lot ? row.sell_lot : "-";
        }
      },
    },
    {
      Header: "Signal Type",
      accessor: "signal_type",
      Cell: ({ row }) => {
        const signal_type = row.signal_type;

        // return signal_type ? signal_type == "buy_sell" ? "BUY" :"SELL" : "-";
        return (
          <>
            {signal_type === "buy_sell" ? (
              <span style={{ color: "green" }}> BUY</span>
            ) : signal_type === "sell_buy" ? (
              <span style={{ color: "red" }}> SELL</span>
            ) : (
              <span style={{ color: "blue" }}> {signal_type}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Entry Time",
      accessor: "buy_time",
      Cell: ({ row }) => {
        const signal_type = row.signal_type;

        if (signal_type === "buy_sell") {
          return row.buy_time ? fDateTimesec(row.buy_time) : "-";
        } else {
          return row.sell_time ? fDateTimesec(row.sell_time) : "-";
        }
      },
    },
    {
      Header: "Exit time",
      accessor: "sell_time",

      Cell: ({ row }) => {
        const signal_type = row.signal_type;

        if (signal_type === "sell_buy") {
          return row.buy_time ? fDateTimesec(row.buy_time) : "-";
        } else {
          return row.sell_time ? fDateTimesec(row.sell_time) : "-";
        }
      },
    },
    activeMarket === "USD" ? {
      Header: "switch",
      accessor: "switch",
      Cell: ({ row }) => {
        return (
          <span onClick={(e) => ChangeTradeType(row)}>
            <ArrowLeftRight />
          </span>
        );
      },
    } : {
      Header: "switch",
      accessor: "switch",
      Cell: ({ row }) => {
        return (
          <span onClick={(e) => INRChangeTradeType(row)}>
            <ArrowLeftRight />
          </span>
        );
      },
    },
    // {
    //   Header: "Reopen Trade",
    //   accessor: "Reopen",
    //   Cell: ({ row }) => {
    //     const { buy_price, sell_price, signal_type } = row;

    //     if (!buy_price || !sell_price) return "--";

    //     const exit_time =
    //       signal_type === "sell_buy"
    //         ? row.buy_time
    //         : row.sell_time;


    //     if (!exit_time) return "--";

    //     const exitDateObj = new Date(exit_time);
    //     if (isNaN(exitDateObj.getTime())) return "--";

    //     const exitDate = exitDateObj.toISOString().split("T")[0];
    //     const today = new Date().toISOString().split("T")[0];

    //     if (exitDate !== today) return "--";

    //     return (
    //       <span
    //         onClick={() => ReopenExitTradedata(row)}
    //         style={{ cursor: "pointer", color: "green" }}
    //       >
    //         <LockOpen />
    //       </span>
    //     );
    //   }
    // },
    // {
    //   Header: "Delete Order",
    //   accessor: "deleteorder",
    //   Cell: ({ row }) => {
    //     const { buy_price, sell_price, del } = row;

    //     if (!buy_price || !sell_price) {
    //       return "--";
    //     }

    //     if (del == 1) {
    //       return "--"
    //     }

    //     return (
    //       <span style={{ cursor: "pointer", color: "red" }} onClick={(e) => DeleteExitTradedata(row)}>
    //         <Trash2 />
    //       </span>

    //     );
    //   },
    // },
    // {
    //   Header: "Deleted Undo",
    //   accessor: "deleteReopenTrade",
    //   Cell: ({ row }) => {
    //     const { buy_price, sell_price, del } = row;

    //     if (!buy_price || !sell_price) {
    //       return "--";
    //     }

    //     if (del == 0) {
    //       return "--"
    //     }

    //     return (
    //       <span style={{ cursor: "pointer", color: "green" }} onClick={(e) => ReopenDeleteExitTradedata(row)}>
    //         <Redo2 />
    //       </span>

    //     );
    //   },
    // },

    {
      Header: "Trade Logs",
      accessor: "Logs",
      Cell: ({ row }) => {
        return (
          <span onClick={(e) => logspage(row)}>
            <Logs style={{ color: "red" }} />
          </span>
        );
      },
    },
    {
      Header: "Deleted Logs",
      accessor: "Logs",
      Cell: ({ row }) => {
        return (
          <span onClick={(e) => fetchTradeLogs(row)}>
            <Logs style={{ color: "blue" }} />
          </span>
        );
      },
    },
  ];


  const columns2 = [
    { Header: "Admin Name", accessor: "Superadmin" },
    { Header: "UserNames", accessor: "UserName" },
    { Header: "Symbol", accessor: "Symbol" },
    {
      Header: "Type",
      accessor: "type",
      Cell: ({ row }) => {
        return row.type === "sell_buy" ? "buy_sell" : "sell_buy"
      }

    },
    {
      Header: "Message", accessor: "message",
      Cell: ({ row }) => {
        return row.message === "Order type switched to sell_buy" ? "Order type switched BUY to SELL" : "Order type switched SELL to BUY"
      }
    },
    {
      Header: "UpdatedAt",
      accessor: "updatedAt",
      Cell: ({ row }) => {
        return fDateTimesec(row.updatedAt);
      },
    },
  ];



  const columns3 = [
    {
      Header: "S.No",
      id: "rowIndex",
      Cell: ({ index }) => (page - 1) * rowsPerPage + index + 1,
    },
    {
      Header: "S.No",
      id: "rowIndex",
      Cell: ({ index }) => (page - 1) * rowsPerPage + index + 1,
    },

    { Header: "Type", accessor: "action_type" },
    { Header: "Buy Price", accessor: "buy_price" },
    { Header: "Sell Price", accessor: "sell_price" },

    {
      Header: "PNL",
      accessor: "pnl",
      Cell: ({ row }) => {
        const value = Number(row.pnl);
        return !isNaN(value) ? value.toFixed(decimalPoint) : "0.00";
      },
      sortable: true,
    },

    {
      Header: "Margin Used",
      accessor: "margin_used",
      Cell: ({ row }) => {
        const value = Number(row.margin_used);
        return !isNaN(value) ? value.toFixed(decimalPoint) : "0.00";
      },
    },

    { Header: "Brokerage Applied", accessor: "brokerage_applied" },

    {
      Header: "Balance Before",
      accessor: "balance_before",
      Cell: ({ row }) => {
        const value = Number(row.balance_before);
        return !isNaN(value) ? value.toFixed(decimalPoint) : "0.00";
      },
    },

    {
      Header: "Balance After",
      accessor: "balance_after",
      Cell: ({ row }) => {
        const value = Number(row.balance_after);
        return !isNaN(value) ? value.toFixed(decimalPoint) : "0.00";
      },
    },

    {
      Header: "requiredFund",
      accessor: "requiredFund",
      Cell: ({ row }) => {
        const value = Number(row.requiredFund);
        return !isNaN(value) ? value.toFixed(decimalPoint) : "0.00";
      },
    },

    {
      Header: "Entry Type",
      accessor: "signal_type",
      Cell: ({ row }) => {
        return row?.signal_type === "sell_buy" ? "SELL" : "BUY";
      },

    },

    {
      Header: "UpdatedAt",
      accessor: "timestamp",
      Cell: ({ row }) => fDateTimesec(row.timestamp),
    },
  ];




  const GetUserName = async () => {
    try {
      const response = await getAdminName();
      if (response.status) {
        setUserName(response.data);
        setUserId(response.data[0]);
      }
    } catch (error) { }
  };

  const calculateTotalProfitLoss = () => {
    if (!Array.isArray(data)) return "0.0000";
    return data
      .reduce((total, row) => {
        const sellPrice = row.sell_price;
        const buyPrice = row.buy_price;
        const buyQty = row.buy_qty;
        const signal_type = row.signal_type;
        if (sellPrice && buyPrice && buyQty) {
          return total + (sellPrice - buyPrice) * buyQty;

        }
        return total;
      }, 0)
      .toFixed(decimalPoint);
  };

  const totalProfitLoss = calculateTotalProfitLoss();

  const ChangeTradeType = async (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to change trade type?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const data = { id: row._id, adminid: TokenData.user_id };
        const response = await switchOrderType(data);

        if (response.status) {
          Swal.fire("Success!", "Trade type changed successfully.", "success");
          getuserallhistory();
        } else {
          Swal.fire("Error!", "Something went wrong.", "error");
        }
      }
    });
  };




  const INRChangeTradeType = async (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to change trade type?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const data = { id: row._id, adminid: TokenData.user_id };
        const response = await InrswitchOrderType(data);

        if (response.status) {
          Swal.fire("Success!", "Trade type changed successfully.", "success");
          getuserallhistory();
        } else {
          Swal.fire("Error!", "Something went wrong.", "error");
        }
      }
    });
  };




  const fetchChangeTradeType = async (row) => {
    const response = await getAllswitchOrderTypedata();
    if (response.status) {
      setLogsdata(response.data)
    } else {
      alert("Error");
    }
  };



  const InrfetchChangeTradeType = async (row) => {
    const response = await InrgetAllswitchOrderTypedata();
    if (response.status) {
      setLogsdata(response.data)
    } else {
      alert("Error");
    }
  };


  useEffect(() => {
    if (logsmodel) {
      if (activeMarket == "USD") {
        fetchChangeTradeType()
      } else {
        InrfetchChangeTradeType()
      }
    }
  }, [logsmodel])


  const handlePageChange = (newPage) => {
    setPage(newPage);         // Table1 prev/next se ye call karega
  };

  const handleRowsPerPageChange = (newPerPage) => {
    setRowsPerPage(newPerPage);
  };

  const handleRefreshAll = () => {
    setUserId("");          // admin dropdown empty
    setUserNamed("");       // user dropdown empty
    setFromDate("");
    setToDate("");
    setTradeStatus("");
    setSearch("");
    setPage(1);
  };


  return (
    <>
      <div>
        <div className="container-fluid mt-5">
          <div className="row">
            <div className="col-lg-12">
              <div className="card transaction-table" style={{ background: "#F7F7F7" }}>

                <div className="card-header border-0 flex-wrap  d-flex justify-content-between align-items-center">

                  <h4 className="card-title mb-0">📊 Trade History</h4>

                  <div className="d-flex align-items-center">


                    <div className="wallet-tabs ">
                      <div className="btn-group" role="group">
                        {TokenData?.market.includes(0) && (
                          <button
                            type="button"
                            className={`btn ${activeMarket === "USD"
                              ? "btn-primary"
                              : "btn-outline-primary"
                              }`}
                            onClick={() => setActiveMarket("USD")}
                          >
                            <i className="fas fa-dollar-sign me-2"></i>
                            USD Wallet
                          </button>
                        )}

                        {TokenData?.market.includes(1) && (
                          <button
                            type="button"
                            className={`btn ${activeMarket === "INR"
                              ? "btn-primary"
                              : "btn-outline-primary"
                              }`}
                            onClick={() => setActiveMarket("INR")}
                          >
                            <i className="fas fa-rupee-sign me-2"></i>
                            INR Wallet
                          </button>
                        )}
                      </div>
                    </div>



                  </div>
                </div>

                <div className="card-body p-0">
                  <div className="tab-content" id="myTabContent1">
                    <div
                      className="tab-pane fade show active"
                      id="Week"
                      role="tabpanel"
                      aria-labelledby="Week-tab"
                    >
                      <div className="row gx-3 gy-2 p-3 ms-3 mt-3">
                        <div className="col-md-3">
                          <label className="fw-bold mb-1">🛡️ Admin</label>
                          <select
                            className="form-select"
                            onChange={(e) => {
                              const selectedUser = userName.find(
                                (u) => u._id === e.target.value
                              );
                              setUserId(selectedUser);
                              setPage(1);
                            }}
                            value={Userid?._id || ""}
                          >
                            <option value="">Select a user</option>
                            {userName &&
                              userName.map((username) => (
                                <option key={username._id} value={username._id}>
                                  {username.UserName}
                                </option>
                              ))}

                          </select>

                        </div>

                        <div className="col-md-3">
                          <label className="fw-bold mb-1">Search</label>
                          <select
                            className="form-select"
                            onChange={(e) => {
                              setUserNamed(e.target.value);
                              setPage(1);
                            }}
                            value={userNamed}
                          >
                            <option value="">Select a user</option>
                            {userNameList &&
                              userNameList.map((u) => (
                                <option key={u.id} value={u.id}>
                                  {u.name}
                                </option>
                              ))}
                          </select>

                        </div>

                        <div className="col-md-3">
                          <label className="fw-bold mb-1">📈 Trade Status</label>
                          <select
                            className="form-select"
                            onChange={(e) => setTradeStatus(e.target.value)}
                            value={tradeStatus}
                          >
                            <option value="">All Trades</option>
                            <option value="open">✔️ Open Trades</option>
                            <option value="close">⛔ Closed Trades</option>

                          </select>
                        </div>

                        <div className="col-md-3">
                          <label className="fw-bold mb-1">🔍 Search</label>
                          <input
                            type="text"
                            placeholder="Search..."
                            className="form-control "
                            onChange={(e) => {
                              setSearch(e.target.value)
                              setPage(1)
                            }}
                            value={Search}
                          />
                        </div>

                        {/* <div className="mt-3 d-flex gap-3">
                         <div className="col-md-2 ">
                          <label className="fw-bold mb-1">📅 From Date</label>
                          <input
                            type="date"
                            className="form-control"
                            onChange={(e) => setFromDate(e.target.value)}
                            value={fromDate}
                          />
                        </div>

                        <div className="col-md-2">
                          <label className="fw-bold mb-1">📅 To Date</label>
                          <input
                            type="date"
                            className="form-control"
                            onChange={(e) => setToDate(e.target.value)}
                            value={toDate}
                          />
                        </div>

                        <div className="col-md-3 d-flex align-items-end">
                          <button
                            className="btn btn-outline-secondary w-100"
                            onClick={getuserallhistory}
                          >
                            <i className="fa-solid fa-arrows-rotate"></i>{" "}
                            Refresh
                          </button>
                        </div>
                        <div className="col-md-5 d-flex align-items-end justify-content-around ">
                          <h3>
                            💰 Total Profit/Loss:{" "}
                            <span
                              style={{
                                color: totalProfitLoss > 0 ? "green" : "red",
                              }}
                            >
                              {(Number(totalProfitLoss) || 0).toFixed(2)}
                            </span>
                          </h3>
                          <div
                            onClick={() => setLogsmodel(true)}
                            className="btn btn-primary"
                            style={{ cursor: "pointer", justifyContent: "end", alignItems: "end", display: "flex" }}
                          >
                            Logs
                          </div>
                        </div>
                       </div> */}
                        <div className="mt-3 row gx-3 gy-2 align-items-end">

                          {/* From Date */}
                          <div className="col-md-2">
                            <label className="fw-bold mb-1">📅 From Date</label>
                            <input
                              type="date"
                              className="form-control"
                              onChange={(e) => setFromDate(e.target.value)}
                              value={fromDate}
                            />
                          </div>

                          {/* To Date */}
                          <div className="col-md-2">
                            <label className="fw-bold mb-1">📅 To Date</label>
                            <input
                              type="date"
                              className="form-control"
                              onChange={(e) => setToDate(e.target.value)}
                              value={toDate}
                            />
                          </div>

                          {/* Profit/Loss & Buttons */}
                          <div className="col-md-8 d-flex justify-content-between align-items-center">

                            {/* Total Profit/Loss */}
                            <h3 className="mb-2">
                              💰 Total Profit/Loss:{" "}
                              <span style={{ color: totalProfitLoss > 0 ? "green" : "red" }}>
                                {(Number(totalProfitLoss) || 0).toFixed(decimalPoint)}
                              </span>
                            </h3>

                            {/* Buttons */}
                            <div className="d-flex gap-2  ">
                              <button
                                className="btn  btn-dark btn-sm"
                                onClick={handleRefreshAll}
                              >
                                <i className="fa-solid fa-arrows-rotate"></i> Refresh
                              </button>
                              <button
                                className="btn btn-sm btn-primary py-2 px-2"
                                onClick={() => setLogsmodel(true)}
                              >
                                Logs
                              </button>


                              <button
                                className="btn btn-success btn-sm"
                                onClick={downloadExcel}
                              >
                                📥 Download Excel
                              </button>

                            </div>

                          </div>
                        </div>

                      </div>

                      <div className="px-3">
                        <Table
                          columns={columns}
                          data={data}
                          page={page}
                          totalPages={totalPages}
                          initialRowsPerPage={rowsPerPage}
                          onPageChange={handlePageChange}
                          onRowsPerPageChange={handleRowsPerPageChange}
                        />


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {logsmodel && (
        <div
          className="modal show d-block"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1050,
          }}
        >
          <div className="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content shadow-lg rounded-3">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title text-white">📋 System Logs</h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setLogsmodel(false)}
                  style={{
                    background: "transparent",
                    border: "none",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                >
                  <X size={20} />
                </button>
              </div>
              <Table columns={columns2} data={logsdata} />
            </div>
          </div>
        </div>
      )}


      {deletelogs && (
        <div
          className="modal show d-block"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1050,
          }}
        >
          <div className="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content shadow-lg rounded-3">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title text-white">📋 Logs</h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setDeleteLogs(false)}
                  style={{
                    background: "transparent",
                    border: "none",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                >
                  <X size={20} />
                </button>
              </div>
              <Table columns={columns3} data={tradeLogs} />
            </div>
          </div>
        </div>
      )}

    </>
  );
};

export default SuperAdminTradeHistory;